var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCondition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_5979_2427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7749 16.3896C20.4158 17.5005 19.6113 18.8891 18.3313 18.8891H1.66855C0.386017 18.8891 -0.414747 17.4983 0.224906 16.3896L8.55637 1.94414C9.19758 0.832717 10.8036 0.834731 11.4437 1.94414L19.7749 16.3896ZM10 13.403C9.11789 13.403 8.40279 14.1181 8.40279 15.0002C8.40279 15.8823 9.11789 16.5974 10 16.5974C10.8821 16.5974 11.5972 15.8823 11.5972 15.0002C11.5972 14.1181 10.8821 13.403 10 13.403ZM8.48359 7.66181L8.74116 12.384C8.7532 12.605 8.93591 12.778 9.1572 12.778H10.8428C11.0641 12.778 11.2468 12.605 11.2589 12.384L11.5164 7.66181C11.5295 7.42313 11.3394 7.22244 11.1004 7.22244H8.89959C8.66057 7.22244 8.47057 7.42313 8.48359 7.66181Z",
    fill: "#7E92B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5979_2427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondition);
export default __webpack_public_path__ + "static/media/condition.384def35.svg";
export { ForwardRef as ReactComponent };